import React from "react";
import { Collapse } from "@mui/material";

export const MiCollapse = (props) => {
  const { ...rest } = props;

  return <Collapse {...rest}></Collapse>;
};
